module.exports = __webpack_public_path__ + "img/faq-5.f1ae0798.png";